/* Claude fixes 66: small replacement for lazysizes. lazysizes re-measured every lazy image after ANY change anywhere on the page (it watched all attribute changes) and on every scroll, which forced page layout again and again on phones. This uses IntersectionObserver instead: the browser says when an image comes near the screen, without forcing layout. Same classes (lazyload / lazyloading / lazyloaded) and the same 'lazyloaded' event, so theme CSS and scripts keep working. */
(function () {
  if (window.fbLazy) return;
  var dpr = Math.min(window.devicePixelRatio || 1, 3);
  var defW = [];
  for (var r = 0, e = 0; e < 3000;) { r += 5; if (r > 30) r += 1; e = 36 * r; defW.push(e); }
  var SLIDER = '[data-flickity-slider],.flickity-enabled,.data-main-slider,.data-thumb-slider,.yv-product-slider,.yv-product-small-slider';
  var seen = new WeakSet();

  function widths(img) {
    var a = img.getAttribute('data-widths');
    try { a = a && JSON.parse(a); } catch (x) { a = null; }
    return a && a.length ? a : defW;
  }

  function unveil(img, w) {
    if (!img.classList.contains('lazyload')) return;
    var src = img.getAttribute('data-src') || '', ss = img.getAttribute('data-srcset'), ds = img.getAttribute('data-sizes');
    if (!w || w < 40) w = img.offsetWidth || (img.parentNode && img.parentNode.offsetWidth) || 300;
    var pic = img.parentNode && img.parentNode.tagName === 'PICTURE' ? img.parentNode : null;
    if (pic) pic.querySelectorAll('source[data-srcset]').forEach(function (s) { s.srcset = s.getAttribute('data-srcset'); });
    img.classList.remove('lazyload');
    img.classList.add('lazyloading');
    var done = function () {
      img.classList.remove('lazyloading');
      img.classList.add('lazyloaded');
      img.dispatchEvent(new CustomEvent('lazyloaded', { bubbles: true, cancelable: false }));
    };
    if (img.tagName === 'IMG') {
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', done, { once: true });
    }
    if (ds === 'auto') img.sizes = Math.round(w) + 'px';
    else if (ds) img.sizes = ds;
    if (src.indexOf('{width}') > -1) {
      var ws = widths(img), set = [], pick = null, need = w * dpr;
      for (var i = 0; i < ws.length; i++) {
        set.push(src.replace(/\{width\}/g, ws[i]) + ' ' + ws[i] + 'w');
        if (pick === null && ws[i] >= need) pick = ws[i];
      }
      if (pick === null) pick = ws[ws.length - 1];
      img.srcset = set.join(', ');
      img.src = src.replace(/\{width\}/g, pick);
    } else {
      if (ss) img.srcset = ss;
      if (src) img.src = src;
    }
    if (img.tagName !== 'IMG' || (img.complete && img.naturalWidth)) done();
    seen.delete(img);
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      var t = en.target;
      io.unobserve(t);
      if (t.classList.contains('lazyload')) { unveil(t, en.boundingClientRect.width); return; }
      // A slider: load all its images, so the next slides are ready before they slide in.
      t.querySelectorAll('.lazyload').forEach(function (img) {
        var w = img.offsetWidth;
        if (w || !img.closest('[hidden],.d-none')) { img.loading = 'eager'; unveil(img, w); }
        else if (!seen.has(img)) { seen.add(img); io.observe(img); }
      });
    });
  }, { rootMargin: '400px 0px' });

  var sliders = new WeakSet();
  function scan() {
    document.querySelectorAll('.lazyload').forEach(function (img) {
      if (seen.has(img)) return;
      seen.add(img);
      var box = img.closest(SLIDER);
      if (box) { if (!sliders.has(box)) { sliders.add(box); io.observe(box); } else io.observe(img); }
      else io.observe(img);
    });
  }
  var t = null;
  function later() { if (!t) t = setTimeout(function () { t = null; scan(); }, 60); }
  window.fbLazy = { scan: scan, unveil: unveil };
  // lazysizes-style API for any code that still calls it
  window.lazySizes = window.lazySizes || { loader: { unveil: function (el) { unveil(el, 0); }, checkElems: scan }, autoSizer: { checkElems: function () {} }, cfg: {} };
  scan();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  // New content (filters, cart drawer, apps) or an image that gets 'lazyload' back: only looks up class names, never measures the page.
  new MutationObserver(later).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
})();
